import React from "react";
import { useTimeAgo } from "rooks";
import styles from "./styles.module.scss";

const toTitleCase = (str: string): string => {
	return str
		.toLowerCase()
		.replace(/[^a-zA-Z0-9 ]/g, '')
		.replace(/\b\w/g, (char) => char.toUpperCase());
}

export const RefreshedAgo = ({ time }: { time: Date }) => {
	const refreshTimeAgo = useTimeAgo(time);
	return (
		<span className={styles.timeAgo}>
			Refreshed  {toTitleCase(refreshTimeAgo || "")}
		</span>
	);
};
